import axios, { AxiosInstance } from 'axios';
import { ClientError, GraphQLClient } from 'graphql-request';
import { buildAxiosFetch } from '@lifeomic/axios-fetch';
import { FMSRStore } from 'app/store/store';
import { authInterceptor } from './interceptors';

export class Resolver {
  store: FMSRStore | null = null;

  httpClient: AxiosInstance | null = null;

  masterQueryGraphQLClient: GraphQLClient | null = null;

  setStore = (store: FMSRStore) => {
    this.store = store;
    this.getHttpClient();
  };

  getHttpClient = () => {
    if (!this.httpClient) {
      const axiosHeaders = {
        Accept: 'application/json',
        'Cache-Control': 'private',
        'Content-Type': 'application/json',
      };

      this.httpClient = axios.create({
        headers: axiosHeaders,
      });
    }
    if (this.store) {
      this.httpClient.interceptors.request.use(authInterceptor(this.store));
    }
    return this.httpClient;
  };

  getMasterQueryGraphQLClient = () => {
    if (!this.masterQueryGraphQLClient) {
      const fetch = buildAxiosFetch(this.getHttpClient(), (config) => {
        // eslint-disable-next-line no-param-reassign
        config.baseURL = window.location.origin;
        // eslint-disable-next-line no-param-reassign
        config['@errorType'] = ClientError.name;
        // eslint-disable-next-line no-param-reassign
        config['@authorization'] = true;
        // eslint-disable-next-line no-param-reassign
        config['@testable'] = true;
        return config;
      });
      // @ts-ignore
      this.masterQueryGraphQLClient = new GraphQLClient('graphql', { fetch });
    }
    return this.masterQueryGraphQLClient;
  };
}

export const resolver = new Resolver();
